import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import { FiFacebook, FiInstagram, FiExternalLink, FiDollarSign } from 'react-icons/fi';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  const portalUrl = "https://albertorodriguez.mytaxportal.online/";

  return (
    <footer className="bg-blue-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold tracking-tighter mb-4">
              Inmi<span className="text-blue-500">Taxes</span>
            </h3>
            <p className="text-blue-200 max-w-sm mb-6 text-sm leading-relaxed">
              {t('contact.subtitle')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/tito406?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-blue-900/50 flex items-center justify-center hover:bg-blue-600 transition-all duration-300 group"
                title="Facebook"
              >
                <SafeIcon icon={FiFacebook} className="w-6 h-6 group-hover:scale-110 transition-transform" />
              </a>
              <a 
                href="https://www.instagram.com/alberth406?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-blue-900/50 flex items-center justify-center hover:bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-600 transition-all duration-300 group"
                title="Instagram"
              >
                <SafeIcon icon={FiInstagram} className="w-6 h-6 group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 border-b border-blue-800 pb-2 inline-block">{t('nav.services')}</h4>
            <ul className="space-y-3 text-blue-200 text-sm">
              <li><a href="#services" className="hover:text-white transition-colors">{t('services.immigration.title')}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t('services.taxes.title')}</a></li>
              <li>
                <a 
                href={portalUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-400 font-bold hover:text-white transition-colors flex items-center gap-1"
                >
                  {t('nav.portal')} <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 border-b border-blue-800 pb-2 inline-block">Pagos / Payments</h4>
            <div className="bg-blue-900/40 p-4 rounded-xl border border-blue-800/50">
              <div className="flex items-center gap-3 text-purple-300 mb-2">
                <SafeIcon icon={FiDollarSign} className="w-5 h-5" />
                <span className="font-bold text-base">Zelle</span>
              </div>
              <p className="text-xl font-mono tracking-wider font-bold text-white">
                (661) 677-4253
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-900 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-blue-300">
          <p className="mb-4 md:mb-0">&copy; {currentYear} InmiTaxes. {t('footer.rights')}</p>
          <div className="text-xs max-w-xl text-center md:text-right opacity-70">
            <p className="mb-1 font-semibold text-blue-100 flex flex-wrap justify-center md:justify-end gap-x-4">
              <a href="mailto:Alberto.406@hotmail.com" className="hover:text-white transition-colors text-sm">Alberto.406@hotmail.com</a> 
              <a href="tel:6616774253" className="hover:text-white transition-colors text-sm">(661) 677-4253</a>
            </p>
            <p className="italic">* {t('footer.disclaimer')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;